/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import TreePermit from '../src/containers/TreePermit';
import TreePermitDetailsPage from '../src/containers/TreePermitDetailsPage';
import TreePermitOrderDetailsPage from '../src/containers/TreePermitOrderDetailsPage';

import routesArray from './routesArray';

interface RouteConfig {
    path: string;
    componentName: keyof typeof Components;
}

const Components = {
    TreePermit,
    TreePermitDetailsPage,
    TreePermitOrderDetailsPage,
};

export default function makeSwitchRoutes() {
    const typedRoutes = routesArray as Array<RouteConfig>;
    const routeComponents = typedRoutes.map((route) => {
        const Component = Components[route.componentName] as React.ComponentType;

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
